module.exports = __webpack_public_path__ + "static/media/models@2x.6fbce8ec.png";